import React from "react";
import { useSelector, useDispatch } from "react-redux";
import classes from "./styles/style.module.css";
import CustomModal from "../../../assets/components/ModalComonent";
import CrossImg from "../../../assets/images/common/crossGroup.svg";
import {
  setShowFinalizeModal,
  setfinalizeQuiz,
} from "../../../assets/redux/actions/Quiz";
import CustomButton from "../../../assets/components/CustomButton";

export default function AnswerQuestion() {
  const { showFinalizeModal } = useSelector(({ quiz }) => quiz);
  const dispatch = useDispatch();

  const handleFinalizeAndClose = () => {
    dispatch(setfinalizeQuiz(true));
    dispatch(setShowFinalizeModal(false));
  };

  const handleClose = () => {
    dispatch(setShowFinalizeModal(false));
  };

  const endMatchDialog = (
    <div className="w-100 text-center">
      <img src={CrossImg} alt="check-vector" className={classes.alertBanner} />
      <p className={classes.smallTitle}> آیا از بازی می خواهید خارج شوید؟</p>
      <div className="w-100 mt-4">
        <CustomButton
          clickHandler={handleFinalizeAndClose}
          styles={{ backgroundColor: "var(--secondary475)" }}
          text={"بله"}
        />
        <CustomButton
          clickHandler={handleClose}
          styles={{
            marginBlock: "16px",
            backgroundColor: "var(--secondary475)",
          }}
          text={"خیر"}
        />
      </div>
    </div>
  );

  return (
    <CustomModal
      open={showFinalizeModal}
      closeHandler={handleClose}
      inputDialog={true}
      dialogContent={endMatchDialog}
    />
  );
}
